<sb-top-nav></sb-top-nav><ng-content></ng-content><sb-footer></sb-footer>
